import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import Checkbox from "../form/Checkbox";
import * as Validation from "../form/Validation";

import { foundHost } from "../../actions/resourceActions";

const Form = ({ handleSubmit, change, history }) => {
  return (
    <form onSubmit={handleSubmit} className="form">
      <Field
        component={TextField}
        label="Název"
        name="name"
        validate={[Validation.required]}
      />
      <Field
        component={TextField}
        label="Adresa"
        name="address"
        validate={[Validation.required]}
      />
      <Field
        component={Checkbox}
        name="dedicated"
        text="Vyhrazen"
        changeValue={change}
      />
      <div className="flex-row flex-right">
        <Button
          flat
          label="Zrušit"
          className="btn"
          onClick={() => history.push("/hosts")}
        />
        <Button
          flat
          primary
          label="Založit"
          type="submit"
          className="btn btn-primary"
        />
      </div>
    </form>
  );
};

export default compose(
  connect(null, { foundHost }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { foundHost, history } = props;

      if (await foundHost(formData)) history.push("/hosts");
      else
        throw new SubmissionError({
          dedicated: "Založení hostitele se nezdařilo."
        });
    }
  }),
  reduxForm({ form: "hostFoundForm" })
)(Form);



// WEBPACK FOOTER //
// ./src/components/hostFound/Form.js